module.exports = __webpack_public_path__ + "static/media/tour search.8a897d0f.svg";